import * as React from 'react'
function SvgAt(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34.062 24.11a6.266 6.266 0 01-5.785 4.6 3.906 3.906 0 01-3.953-2.865 6.607 6.607 0 01-5.413 2.865 5.986 5.986 0 01-4.706-1.928 7.558 7.558 0 01-1.717-5.216 8.47 8.47 0 012.278-6.142c2.447-2.534 5.722-2.618 9.21-2.112 1.025.14 2.036.37 3.021.689-.036.742-.405 8.282-.405 8.98 0 1.96.637 2.94 1.911 2.939.966 0 1.734-.627 2.304-1.882a12.988 12.988 0 00-.431-10.295 9.837 9.837 0 00-9.096-4.941 11.83 11.83 0 00-11.22 6.234 15.196 15.196 0 00-1.525 6.965c0 6.867 3.674 11.055 11.02 11.055 2.9-.036 5.769-.596 8.47-1.653v3.012A21.928 21.928 0 0119.628 36C10.835 36 5.23 31.144 5.23 22.118a17.406 17.406 0 012.057-8.533 15.22 15.22 0 0113.956-7.703c4.85-.259 9.442 2.191 11.928 6.363a14.927 14.927 0 01.89 11.864zM16.01 21.64c0 2.853 1.12 4.28 3.36 4.28 2.363 0 3.655-1.794 3.876-5.382l.22-4.39a5.835 5.835 0 00-6.142 1.25 6.381 6.381 0 00-1.314 4.242z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgAt
